export const trimTextarea = (str) => str.replace(/ {2,}/g, ' ').trim()
